import { useQueryParamValue } from 'src/app/shared/hooks/location';

export function useGuestInfo() {
	const guest = useQueryParamValue('guest');
	const guestShortDisplayName = useQueryParamValue('short_display_name') || '';

	if (!guest || !guestShortDisplayName) {
		return undefined;
	}

	return {
		shortDisplayName: guestShortDisplayName,
	};
}
